<div class="tutorization__message">
  <gl-textarea
    [(ngModel)]="message"
    [label]="'nouns.misTitle' | translate"
    [placeholder]="'actions.writeHere' | translate"
    [skeletorValueAccessor]="textarea"
  ></gl-textarea>
  <gl-button
    color-primary
    [disabled]="!message"
    [text]="'actions.send' | translate"
    (onClick)="sendMessage()"
  ></gl-button>
</div>
